@if (debuggingService.isDebuggingEnabled) {
  <div aria-hidden="true" aria-label="Du befindest Dich hier:"
    class="wba-debug">
    <h1>👷 WBA Debugging Menü 🏗️</h1>
    <h2>Current Antrag FormVersion</h2>
    <h3>Die Funktion ist nur auf der Fachmodulseite oder Tag der Antragstellung verfügbar</h3>
    <div>
      <pre>{{ currentAntragFormVersion | async | json }}</pre>
      <div>
        <input #formVersionInput name="formVersion" type="number" value="1">
        <button (click)="updateAntragFormVersion(formVersionInput.value)">Update</button>
      </div>
    </div>
  </div>
}
